export default "__VITE_ASSET__qyqhH8ei__"